import { getRuntimeConfig } from '@onestep/runtime-config';

import type { PortalRuntimeConfig } from '../../../config/schema';

export type { PortalRuntimeConfig };

export const getPortalRuntimeConfig = () => getRuntimeConfig<PortalRuntimeConfig>();
